import * as React from "react";
import TextField from "@mui/material/TextField";
import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FormHelperText } from "@mui/material";
import { GetAuthUserinfoApi } from "../../../../../services/authApi";
import { checkResponseData } from "../../../utils/utilsFunctions";

const ReferralDiscountForm = ({
  checkRefferlCodeForUse,
  selectedProduct,
  responseReferralMessage,
  handleReferralMessage,
  userReferralCode
}) => {
  const [referralCode, setReferralCode] = React.useState(false);

  const clearReferralCode = async () => {
    handleReferralMessage({
      cleraButton: false,
      resMessage: "",
      disableReferralInput: false,
    });
  };
  const checkReferralCode = async () => {
    const data = {
      marketingCode: referralCode,
      productId: selectedProduct.productId,
    };
    // console.log(data);
    await checkRefferlCodeForUse(data);
  };


  React.useEffect(() => {
    if (userReferralCode) setReferralCode(userReferralCode)
  }, [userReferralCode]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <FormControl
        sx={{ display: "flex", alignItems: "flex-start", flexDirection: "row" }}
      >
        <TextField
          disabled={responseReferralMessage.disableReferralInput}
          id="outlined-basic"
          value={referralCode || ""}
          onChange={(newValue) => setReferralCode(newValue.target.value)}
          size="small"
          label="کد معرف(تخفیف)"
          variant="outlined"
        />
        {responseReferralMessage.cleraButton &&
          responseReferralMessage.disableReferralInput ? (
          <Button
            onClick={clearReferralCode}
            sx={{ mx: 0.3 }}
            color="warning"
            variant="contained"
          >
            حذف
          </Button>
        ) : (
          <Button
            disabled={responseReferralMessage.disableReferralInput}
            sx={{ mx: 0.3 }}
            variant="contained"
            onClick={() => {
              checkReferralCode();
            }}
          >
            ثبت
          </Button>
        )}
      </FormControl>
      <FormHelperText id="outlined-basic">
        {!responseReferralMessage.disableReferralInput
          ? ""
          : responseReferralMessage.resMessage}
      </FormHelperText>

      {/* <TextField id="outlined-basic"  size="small" label="Outlined" variant="outlined" />*/}
    </Box>
  );
};

const OtherDiscountForm = ({
  checkDiscountCodeForUse,
  selectedProduct,
  discountCodeMessage,
  handleDiscountCodeMessage,
}) => {
  const [anotherCode, setAnotherCode] = React.useState(false);

  const clearDiscountCode = async () => {
    handleDiscountCodeMessage({
      cleraButton: false,
      resMessage: "",
      disableDiscountInput: false,
    });
  };
  const checkDiscountCode = async () => {
    const data = {
      discountCode: anotherCode,
      productId: selectedProduct.productId,
    };
    // console.log(data);
    await checkDiscountCodeForUse(data);
  };

  // const clearAnotherCode = async () => {
  //   setResponseReferralMessage({ cleraButton: false, resMessage: "" });
  //   setdisableDiscountInput(false);
  // };
  // const checkAnotherCode = async () => {
  //   setdisableDiscountInput(true);
  //   let response = await checkAnotherCodeBack({
  //     discountCode: anotherCode,
  //     productId: "6300b98320f2f4e5ade17803",
  //   });
  //   const { Discount, codeToken: Token, message } = response.data.data.data[0];
  //   // await  trueRes=res.data.data.data[0]
  //   // if(trueRes) {Discount,codeToken,message}=res.data.data.data[0]
  //   if (response.data.success)
  //     handleAnotherCodeToken({
  //       Discount,
  //       message,
  //       Token,
  //     });
  //   await setResponseReferralMessage({ cleraButton: true, resMessage: message });
  // };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
      <FormControl
        sx={{ display: "flex", alignItems: "flex-start", flexDirection: "row" }}
      >
        <TextField
          disabled={discountCodeMessage.disableDiscountInput}
          id="outlined-basic"
          onChange={(newValue) => setAnotherCode(newValue.target.value)}
          size="small"
          label="کد تخفیف"
          variant="outlined"
        />
        {discountCodeMessage.cleraButton &&
          discountCodeMessage.disableDiscountInput ? (
          <Button
            onClick={clearDiscountCode}
            sx={{ mx: 0.3 }}
            color="warning"
            variant="contained"
          >
            حذف
          </Button>
        ) : (
          <Button
            disabled={discountCodeMessage.disableDiscountInput}
            sx={{ mx: 0.3 }}
            variant="contained"
            onClick={() => {
              // console.log(
              //   discountCodeMessage,
              //   "12312313213",
              //   discountCodeMessage.cleraButton,
              //   discountCodeMessage.disableDiscountInput
              // );
              checkDiscountCode();
            }}
          >
            ثبت
          </Button>
        )}
      </FormControl>
      <FormHelperText id="outlined-basic">
        {!discountCodeMessage.disableDiscountInput
          ? ""
          : discountCodeMessage.resMessage}
      </FormHelperText>

      {/* <TextField id="outlined-basic"  size="small" label="Outlined" variant="outlined" />*/}
    </Box>
  );
};

export { ReferralDiscountForm, OtherDiscountForm };
